import { render, staticRenderFns } from "./Sequences.vue?vue&type=template&id=5d10d27a&scoped=true&"
import script from "./Sequences.vue?vue&type=script&lang=js&"
export * from "./Sequences.vue?vue&type=script&lang=js&"
import style0 from "./Sequences.vue?vue&type=style&index=0&id=5d10d27a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10d27a",
  null
  
)

export default component.exports